import clsx from "clsx";
import React from "react";

import "./shortcuts.list.scss";

export default ({ children, className }) => {
  return <div className={clsx("shortcuts-list", className)}>{children}</div>;
};
